import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { APP_FEATURE_KEY, appReducer } from './app.reducer';
import { AppEffects } from './app.effects';
import { AppFacade } from './app.facade';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(APP_FEATURE_KEY, appReducer), EffectsModule.forFeature([AppEffects])],
    providers: [AppFacade],
})
export class AppStoreModule {}
